export default __webpack_public_path__ + "static/media/Walkin.5c72710c.svg";